import {Injectable} from '@angular/core';

declare const $;

@Injectable()
export class LocalService {

    localStorage: any = window.localStorage;
    themes: string[ ] = ['light', 'dark'];
    theme: string = this.themes[0];

    constructor() {
    }

    get(key) {

        if (this.localStorage) {
            let item = this.localStorage.getItem(key);
            item = JSON.parse(item);
            return item;
        }
        return null;
    }

    set(key: string, item: any) {

        item = JSON.stringify(item);

        if (this.localStorage) {
            this.localStorage.setItem(key, item);
            return true;
        }
        return false;
    }

    getTheme() {
        return this.get('theme') || this.theme;
    }

    setTheme(i: number = null) {

        let oldTheme = this.theme;
        let newTheme = (i != null) ? this.themes[i] : this.getTheme();

        // console.log('newTheme = ', newTheme);

        let $stylesheet = $('#theme-stylesheet');
        let path = $stylesheet.attr('href').replace(new RegExp(oldTheme, 'g'), newTheme);
        $stylesheet.attr('href', path);

        this.theme = newTheme;
        this.set('theme', this.theme);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/local/local.service.ts